import { ManualPricedItem } from "../../models/economy-models";

export const currencyValuesManual: ManualPricedItem[] = [
  { name: "Albino Rhoa Feather", value: 1000 },

  // Tablets
  { name: "Irradiated Tablet", value: 25 },
  { name: "Overseer Tablet", value: 10 },
  { name: "Breach Tablet", value: 50 },
  // { name: "Expedition Tablet", value: 5 },
  { name: "Delirium Tablet", value: 5 },
  { name: "Abyss Tablet", value: 100 },
  { name: "Temple Tablet", value: 30 },
  { name: "Ritual Tablet", value: 250 },

  // Exalted Orb
  { name: "Exalted Orb", value: 1 },

  // Fragments
  { name: "Djinn Barya", value: 0.25 },
  { name: "Inscribed Ultimatum", value: 0.25 },

  // Low value currency

  { name: "Scroll of Wisdom", value: 0.0001 },
  { name: "Transmutation Shard", value: 0.0005 },
  { name: "Regal Shard", value: 0.01 },
  { name: "Artificer's Shard", value: 0.1 },
  // { name: "Orb of Augmentation", value: 0.005 },
  // { name: "Orb of Transmutation", value: 0.01 },
  // { name: "Chance Shard", value: 0.5 },

  // Wombgifts
  { name: "Signet Wombgift", value: 15 },
  { name: "Banded Wombgift", value: 3 },
  { name: "Ornate Wombgift", value: 15 },
  { name: "Lavish Wombgift", value: 75 },
  { name: "Revelatory Wombgift", value: 20 },
];

export const uniquesValuesManual: ManualPricedItem[] = [
];
